import type { AdminConsumptionDay } from '@ddp/shared';

import { DayAreaChart } from './DayAreaChart.js';

/**
 * Courbe de tendance de consommation (ADR-0025, incrément 3). Fine adaptation de `DayAreaChart` :
 * chaque mesure (jetons IA, transfert) a son propre graphe et sa propre échelle — jetons et octets ne
 * partagent **jamais** un axe (deux grandeurs de nature différente sur un même axe induisent en erreur).
 */
interface ConsumptionTrendProps {
  title: string;
  /** Champ de la série à tracer. */
  metric: 'aiTokens' | 'dataTransferBytes';
  days: AdminConsumptionDay[];
  /** Formate une valeur pour l'axe et l'infobulle (jetons → compact, octets → Ko/Mo…). */
  format: (value: number) => string;
  /** Suffixe d'identité pour les classes de couleur : `tokens` (violet) ou `transfer` (sarcelle). */
  accent: 'tokens' | 'transfer';
}

export function ConsumptionTrend({ title, metric, days, format, accent }: ConsumptionTrendProps) {
  const points = days.map((d) => ({ date: d.date, value: d[metric] }));
  return <DayAreaChart title={title} points={points} format={format} accent={accent} />;
}
